import $ from 'jquery';
import validator from 'jquery-validation';
import addMethods from 'jquery-validation/dist/additional-methods';

$;
validator;
addMethods;

/**
 * Implementação custom do validator, para simplificar a montagem de formulários.
 *
 * Exemplo na página: page-contact.blade.php
 */
$.validator.setDefaults({
    onFocusOut: true,
    errorClass: 'input-error',
    errorElement: 'span',
    // errorLabelContainer: '.form-errors',
    errorPlacement: function (error, element) {
        element.next('span').remove();

        if (element.is(':checkbox')) {
            element.parent().after(error).removeClass('field-validation-error').addClass('ui-state-error');
            // error.addClass('error-check');
        } else {
            error.insertAfter(element).removeClass('field-validation-error').addClass('ui-state-error');
        }
    },
    invalidHandler: function (event, validator) {
        const elemForm = $(event.currentTarget);

        elemForm.find("button[type='submit']").removeClass('loading');
        elemForm.find('.form-feedback').empty();

        const actionCaptcha = elemForm.find('input[name="g-recaptcha-response"]').data('action');
        reloadCaptcha(actionCaptcha);
    },
    submitHandler: function (form) {
        const button = $(form).find('button[type=submit]');
        if (button.hasClass('loading')) {
            return;
        }

        button.addClass('loading');

        form.submit();
    },
});
